import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import "./App.css";

import Login from "./pages/LoginPage";
import PublicRoute from "./routes/PublicRoute";

import Weightment from "./pages/WeightmentPage";
import Reminder from "./pages/ReminderPage";
import Upload from "./pages/UploadPage";
import Settings from "./pages/SettingsPage";
import Member from "./pages/MemberPage";
import ForgetPasswordPage from "./pages/ForgetPasswordPage";
import SetPasswordPage from "./pages/SetPasswordPage";
import Document from "./pages/DocumentPage";
import DocumentSingle from "./pages/DocumentSinglePage";
import Driver from "./pages/DriverPage";
import Labour from "./pages/LabourPage";
import Workflow from "./pages/WorkflowPage";
import Dashboard from "./pages/DashboardPage";
import Rake from "./pages/RakePage";
import RakeDetails from "./pages/RakeDetailsPage";
import AI from "./pages/AIPage";
import PrivacyPolicy from "./pages/PrivacyPolicyPage";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>

          <Route path="/privacy" element={<PrivacyPolicy />} />

          <Route
            path="/login"
            element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            }
          />

          <Route
            path="/forget-password"
            element={
              <PublicRoute>
                <ForgetPasswordPage />
              </PublicRoute>
            }
          />

          <Route
            path="/set-password"
            element={
              <PublicRoute>
                <SetPasswordPage />
              </PublicRoute>
            }
          />

          <Route
            path="/dashboard"
            element={
              <PublicRoute>
                <Dashboard />
              </PublicRoute>
            }
          />

          {/* ─── Operations ─────────────────────────────── */}

          <Route
            path="/"
            element={
              <PublicRoute>
                <Weightment />
              </PublicRoute>
            }
          />

          <Route
            path="/upload"
            element={
              <PublicRoute>
                <Upload />
              </PublicRoute>
            }
          />

          <Route
            path="/members"
            element={
              <PublicRoute>
                <Member />
              </PublicRoute>
            }
          />

          <Route
            path="/reminders"
            element={
              <PublicRoute>
                <Reminder />
              </PublicRoute>
            }
          />

          <Route
            path="/documents"
            element={
              <PublicRoute>
                <Document />
              </PublicRoute>
            }
          />

          <Route
            path="/documents/:id"
            element={
              <PublicRoute>
                <DocumentSingle />
              </PublicRoute>
            }
          />

          <Route
            path="/drivers"
            element={
              <PublicRoute>
                <Driver />
              </PublicRoute>
            }
          />

          <Route
            path="/labours"
            element={
              <PublicRoute>
                <Labour />
              </PublicRoute>
            }
          />


          <Route
            path="/rakes"
            element={
              <PublicRoute>
                <Rake />
              </PublicRoute>
            }
          />

          <Route
            path="/rakes/:rakeMasterId"
            element={
              <PublicRoute>
                <RakeDetails />
              </PublicRoute>
            }
          />

          <Route
            path="/ai"
            element={
              <PublicRoute>
                <AI />
              </PublicRoute>
            }
          />

          <Route
            path="/workflow"
            element={
              <PublicRoute>
                <Workflow />
              </PublicRoute>
            }
          />

          <Route
            path="/settings"
            element={
              <PublicRoute>
                <Settings />
              </PublicRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
